import {MdArrowBack} from "react-icons/md";
import {MdArrowForward} from "react-icons/md";
import {MdFormatListBulleted} from "react-icons/md";
import {MdInfoOutline} from "react-icons/md";
import {MdLinearScale} from "react-icons/md";
import {MdLock} from "react-icons/md";
import {MdMenu} from "react-icons/md";
import {MdKeyboardArrowUp} from "react-icons/md";
import {MdArrowUpward} from "react-icons/md";
import {MdLockOutline} from "react-icons/md";
import {MdClose} from "react-icons/md";
import {MdKeyboardArrowDown} from "react-icons/md";
import {MdKeyboardArrowRight} from "react-icons/md";
import {MdMap} from "react-icons/md";
import {MdPlayCircleOutline} from "react-icons/md";
import {MdRadioButtonUnchecked} from "react-icons/md";
import {MdSend} from "react-icons/md";
import {MdUndo} from "react-icons/md";

import {IoMdCheckmark} from "react-icons/io";
import {IoMdRemove} from "react-icons/io";
import {IoMdSquareOutline} from "react-icons/io";

import {IoCartOutline} from "react-icons/io5";
import {IoChatbubblesOutline} from "react-icons/io5";
import {IoSkullOutline} from "react-icons/io5";
import {IoWalletOutline} from "react-icons/io5";

import {RiPushpin2Line} from "react-icons/ri";
import {RiStickyNoteFill} from "react-icons/ri";

const actions = {
    back: <MdArrowBack/>,
    cancel: <MdClose/>,
    close: <MdClose/>,
    down: <MdKeyboardArrowDown/>,
    go: <MdArrowForward/>,
    ok: <IoMdCheckmark/>,
    play: <MdPlayCircleOutline/>,
    remove: <IoMdRemove/>,
    restart: <IoSkullOutline/>,
    pay: <IoWalletOutline/>,
    send: <MdSend/>,
    undo: <MdUndo/>,
    up: <MdKeyboardArrowUp/>,
} as const;

const objects = {
    feedback: <IoChatbubblesOutline/>,
    cart: <IoCartOutline/>,
    help: <MdInfoOutline/>,
    link: <MdArrowUpward/>,
    list: <MdFormatListBulleted/>,
    locker: <MdLockOutline/>,
    map: <MdMap/>,
    menu: <MdMenu/>,
    notes: <RiStickyNoteFill/>,
    place: <IoMdSquareOutline/>,
    pin: <RiPushpin2Line/>,
    restoration: <MdUndo/>,
    route: <MdLinearScale/>,
} as const;

const states = {
    collapsed: <MdKeyboardArrowRight/>,
    expanded: <MdKeyboardArrowDown/>,
    unchecked: <MdRadioButtonUnchecked/>,
    ok: <IoMdCheckmark/>,
    secure: <MdLock/>,
};

export const icons = {
    actions: actions,
    objects: objects,
    states: states,
};

export type IconsType = {
    actions: {
        [key in keyof typeof actions]: string;
    };
    objects: {
        [key in keyof typeof objects]: string;
    };
    states: {
        [key in keyof typeof states]: string;
    };
};
